<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
      <div class="row">
        <div class="col-md-12">
          <ol class="breadcrumb font-class">
            <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
            <li><a href="/#/about" v-on:click="sendMsg">关于</a></li>
            <li class="active">公司简介</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
      <div class="row">
        <div class="center_column col-xs-12 col-sm-12">
          <div class="rte">
            <div><img src="../../assets/company.png" alt=""></div>
            <p> 浙江博远电子科技有限公司位于浙江省嘉兴市，公司是通过精英引才计划落户嘉兴的高新技术企业。
              本公司主要从事振动测量仪器、振动计量仪器的研发、生产、销售、培训，并提供系统测量解决方案。
              博远电子是一家高科技产业公司，拥有以博士团队为基础的专业技术力量，在传感技术、计量技术、
              振动信号分析处理、结构动力学特性分析技术领域汇集了一批具有科研院所背景的博士团队。
              为桥梁、输电塔、通讯塔、机械设备、精密仪器、大型发电机组、水坝、海洋结构平台等提供振动问题的系统解决方案，
              产品应用领域涉及土木水利工程、电力输送、交通运输、地震工程、军事科学、海洋工程等诸多领域。
              公司坚持诚信为本、自主创新、合作共赢的宗旨，努力为客户服务，善待客户每一个期望，珍惜员工每一份努力，
              为本行业和本领域技术水平的进步，为工程测量水平的提高贡献自己的力量。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>
import {getContactDetail} from '../../utils/api'

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
    this.getContactDetail()
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    async getContactDetail () {
      let contactData01 = await getContactDetail()
      if (localStorage.getItem('Language') === 'zh') {
        this.contactData = {
          address: this.render(contactData01.address_zh),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_zh)
        }
      } else {
        this.contactData = {
          address: this.render(contactData01.address_en),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_en)
        }
      }
      // console.log(this.contactData)
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 17px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
  }

  .rte div{
    text-align: center;
    margin-bottom: 20px;
  }

  .rte p{
    text-indent: 34px;
    margin-bottom: 20px;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/about/about-company.vue